<template>
  <div class="dzp">
    <img class="img1" src="../assets/topText.png" alt />
    <h5>
      <span>{{ title }}</span>
    </h5>
    <div class="prize">
      <div class="inner">
        <van-swipe
          :autoplay="3000"
          indicator-color="white"
          :show-indicators="false"
          :vertical="true"
          class="swiper"
        >
          <van-swipe-item class="item" v-for="item in luckUsers" :key="item.id">
            <div class="user">{{ item.tel }}</div>
            <div class="p">抽中了{{ item.turntable_reward_title }}</div>
            <div class="time">{{ item.date }}前</div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <van-dialog v-model="cjshow"  title="恭喜您获得奖品" >
      <img :src="zjpic" style="margin:0 auto;display:block;" class="cj" />
    </van-dialog>
    <div class="ctxBox">
      <canvas
        id="ctx"
        :class=" flag && 'ani'  "
        width="620"
        height="620"
        ref="ctx"
        :style="Ctxstyle"
      ></canvas>
      <img src="../assets/point.png" @click="wantLuck" />
    </div>
    <div class="t1">
      你剩余{{ score }}积分
      <span>{{ need_score }}积分抽取一次</span>
    </div>
    <router-link
      :to="{name:'financeIndex',query: { balance: this.balance }}"
      tag="div"
      class="btn"
    >获取更多抽奖机会</router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Ctxstyle: "",
      imgList: [
        // {
        //   id: 0,
        //   color: "#e42129",
        //   prize: "奖品1",
        //   content: "图片 等描述信息",
        //   img:
        //     "https://img.alicdn.com/imgextra/i3/2616970884/O1CN01xO5uo51IOueaACMO4_!!2616970884.jpg"
        // },
        // {
        //   id: 1,
        //   color: "#ffd7d9",
        //   prize: "奖品2",
        //   content: "图片 等描述信息",
        //   img:
        //     "https://img.alicdn.com/imgextra/i3/2616970884/O1CN01xO5uo51IOueaACMO4_!!2616970884.jpg"
        // },
        // {
        //   id: 2,
        //   color: "#e42129",
        //   prize: "奖品3",
        //   content: "图片 等描述信息",
        //   img:
        //     "https://img.alicdn.com/imgextra/i3/2616970884/O1CN01xO5uo51IOueaACMO4_!!2616970884.jpg"
        // },
        // {
        //   id: 3,
        //   color: "#ffd7d9",
        //   prize: "奖品4",
        //   content: "图片 等描述信息",
        //   img:
        //     "https://img.alicdn.com/imgextra/i3/2616970884/O1CN01xO5uo51IOueaACMO4_!!2616970884.jpg"
        // },
        // {
        //   id: 4,
        //   color: "#e42129",
        //   prize: "奖品5",
        //   content: "图片 等描述信息",
        //   img:
        //     "https://img.alicdn.com/imgextra/i3/2616970884/O1CN01xO5uo51IOueaACMO4_!!2616970884.jpg"
        // },
        // {
        //   id: 5,
        //   color: "#ffd7d9",
        //   prize: "奖品6",
        //   content: "图片 等描述信息",
        //   img:
        //     "https://img.alicdn.com/imgextra/i3/2616970884/O1CN01xO5uo51IOueaACMO4_!!2616970884.jpg"
        // },
        // {
        //   id: 6,
        //   color: "#e42129",
        //   prize: "奖品7",
        //   content: "图片 等描述信息",
        //   img:
        //     "https://img.alicdn.com/imgextra/i3/2616970884/O1CN01xO5uo51IOueaACMO4_!!2616970884.jpg"
        // },
        // {
        //   id: 7,
        //   color: "#ffd7d9",
        //   prize: "奖品8",
        //   content: "图片 等描述信息",
        //   img:
        //     "https://img.alicdn.com/imgextra/i3/2616970884/O1CN01xO5uo51IOueaACMO4_!!2616970884.jpg"
        // }
      ],
      flag: false,
      id: "",
      title: "",
      need_score: "",
      score: "",
      zjpic: "",
      cjshow: false,
      luckUsers: [],
      balance: ""
    };
  },

  mounted() {
    setinterval(() => {

      this.getLuckUsers();

    }, 10000);


  },
  created() {
    this.id = this.$route.query.id;
    this.reward();
    this.getDefaultReceive();
    this.getLuckUsers();

    this.getMyinfo();
  },

  methods: {
    getMyinfo() {
      this.$http({
        url: "my"
      }).then(res => {
        this.balance = res.data.balance;
      });
    },

    // 获取用户是否有设置默认地址
    getDefaultReceive() {
      this.$http({ url: "getDefaultReceive" }).then(res => {
        if (!res.id) {
          this.$dialog
            .alert({
              message: "请先添加默认收货地址",
              confirmButtonText: "去设置"
            })
            .then(() => {
              // 跳转到 添加地址页
              this.$router.push({ name: "addAddress" });
            });
        }
      });
    },

    // 获取 中奖信息
    getLuckUsers() {
      this.$http({
        url: "getLuckUsers",
        data: {
          id: this.id
        }
      }).then(res => {
        let list = res;

        list.forEach(item => {
          // 修改手机号
          if (item.tel != null) {
            item.tel = item.tel.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
          }
          function filter(val){
            if(val < 1){
              return '刚刚'
            }else if(val > 1 && val < 60){
              return val + '分钟'
            }else if(val > 60 && val < 60 * 24){
              return Math.floor(val / 60) + '小时'
            }else if(val > 60 * 24  && val < 60 * 24 * 30){
              return Math.floor(val / 60 / 24) + '天'
            }else if(val > 60 * 24 * 30){
              return Math.floor(val / 60 / 24 / 30 ) + '月'
            }

          }




          item.date = filter(Math.floor(
            Math.floor(
              (new Date() -
                new Date(item.add_time.replace(/-/g, "/")).getTime()) /
                1000
            ) / 60
          ))
        });

        this.luckUsers = list;
      });
    },

    // 获取活动奖品
    wantLuck() {
      if (this.flag) return;
      this.flag = true;
      this.$http({
        url: "wantLuck",
        data: {
          id: this.id
        }
      })
        .then(res => {
          let id = res.id;

          let imgList = this.imgList;

          let index = imgList.findIndex(item => item.id == id);

          let length = this.imgList.length;

          // let deg =(index * 360) / length + 360 / length / 10 + Math.floor(Math.random() * (360 / length + 1));

          let deg =
            (index * 360) / length +
            360 / length / 10 +
            Math.floor(Math.random() * (((360 / length) * 8) / 10));

          this.Ctxstyle = `transform:rotate(${1800 +
            360 / length / 2 -
            deg}deg)`;

          setTimeout(() => {
            this.Ctxstyle = `transform:rotate(${360 / length / 2 - deg}deg)`;
            this.score = Math.floor(this.score) - this.need_score;
            if (!id) {
              this.$dialog.alert({
                message: "很遗憾未中奖"
              });
            } else {
              this.cjshow = true;
              this.zjpic = res.pic;
            }
            this.flag = false;
          }, 6000);
        })
        .catch(err => {
          if (err.response.status == 301) {
            // 未设置默认地址
            this.$toast(err.response.data);
            
          }else if(err.response.status == 302){
            this.$toast(err.response.data);

            setTimeout(() => {
              this.$router.replace({ name: "index" });
            }, 1000);
          }
        });
    },

    
    reward() {
      this.$http({
        url: "reward",
        data: {
          id: this.id
        }
      })
        .then(res => {
          // console.log(res)

          let list = res.reward;





          let arr = list.map((item, index) => {
            if (index % 2) {
              item.color = "#e42129";
            } else {
              item.color = "#ffd7d9";
            }
            item.prize = item.title;
            item.img = item.pic;
            return item;
          });
          let sum =0
          list.forEach(item=>{
            sum += item.probability * 100
          })


          if(sum/100 < 100){
             arr.push({
              id: 0,
              color: "#f9f9f9",
              prize: "未中奖",
              content: "图片 等描述信息",
              img:
                "https://img.alicdn.com/imgextra/i3/2616970884/O1CN01xO5uo51IOueaACMO4_!!2616970884.jpg"
            });
          }
          this.imgList = arr;

          this.title = res.title;
          this.need_score = res.need_score;
          this.score = res.score;
          this.huitu();
        })
        .catch(err => {
          if (err.response.status == 301) {
            this.$toast(err.response.data)
          }
          else if (err.response.status == 302) {
            this.$toast(err.response.data);
            setTimeout(() => {
              this.$route.replace({ name: "index" });
            }, 1000);
          }
        });
    },
    huitu() {
      this.canvas = this.$refs.ctx;
      this.ctx = this.canvas.getContext("2d");
      let length = this.imgList.length;
      let pan = new Image();
      pan.src = require("../assets/pan.png");
      pan.onload = () => {
        this.ctx.drawImage(pan, 0, 0, 620, 620);
        let imgList = this.imgList;

        this.ctx.translate(84, 84);

        let size = 620 - 2 * 84;

        imgList.forEach((ele, index) => {
          let img = new Image();
          img.src = ele.img;
          img.onload = () => {
            this.ctx.save();
            this.ctx.beginPath();
            // 移动到圆心
            this.ctx.translate(size / 2, size / 2);
            this.ctx.moveTo(0, 0);

            // 旋转角度
            // this.ctx.rotate((-90 - 180/length ) * Math.PI/180)
            this.ctx.rotate(
              (((360 / length) * index - 90 - 180 / length) * Math.PI) / 180
            );
            // this.ctx.rotate((360 / length * index + 360 / length -90 ) * Math.PI/180)
            // 绘制圆弧
            this.ctx.arc(0, 0, size / 2, 0, (2 * Math.PI) / length, false);

            // 填充扇形
            this.ctx.fillStyle = ele.color;
            this.ctx.fill();
            this.ctx.lineWidth = 0.5;
            this.ctx.strokeStyle = ele.color;
            this.ctx.stroke();
            // 绘制文字

            this.ctx.fillStyle = "#000";
            this.ctx.font = "18px sans-serif ";

            let deg = 180 / length;
            this.ctx.translate(
              size / 4,
              (Math.sin((deg * Math.PI) / 180) * (size / 4)) /
                Math.sin(((90 - deg) * Math.PI) / 180)
            );

            this.ctx.moveTo(0, 0);
            this.ctx.rotate(((90 + 180 / length) * Math.PI) / 180);
            this.ctx.textAlign = "center";
            this.ctx.fillText("·", 0, 0);
            this.ctx.fillText(ele.prize, 0, -(size / 8) + 20);
            // 绘制图片
            this.ctx.drawImage(img, -30, -30, 60, 60);
            this.ctx.restore();
          };
          this.Ctxstyle = `transform:rotate(${360 / length / 2}deg);`;
        });
      };
    }
  }
};
</script>

<style lang="less" scoped>
.dzp {
  position: fixed;
  width: 100%;
  // height: 814px;
  height: 100%;
  background: #c21017 url("../assets/bg.png") no-repeat;
  background-size: 100%;
  padding-top: 70px;
  h5 {
    font-size: 60px;
    width: 100%;
    text-align: center;
    font-weight: 900;
    font-style: italic;
    color: #fff;
    -webkit-text-stroke: 1px #ffcd46;
    text-shadow: 5px 5px 0 #fff;
  }
  .img1 {
    width: 644px;
    display: block;
    margin: 0 auto;
  }
  .prize {
    width: 520px;
    height: 62px;
    border-top: 2px solid #e42129;
    border-bottom: 2px solid #e42129;
    margin: 40px auto;
    .inner {
      width: 580px;
      height: 62px;
      margin-left: -20px;

      font-size: 28px;
      color: #fff;
      font-style: italic;
      .swiper {
        height: 62px;
        width: 100%;
        .item {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }
  }
  .ctxBox {
    margin: 0 auto;
    width: 620px;
    height: 620px;
    position: relative;
    #ctx {
      width: 100%;
      height: 100%;
    }
    .ani {
      transition: all 5s ease;
    }
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 200px;
      margin-left: -100px;
      margin-top: -130px;
    }
  }
  .t1 {
    text-align: center;
    font-size: 36px;
    color: #fff;
    span {
      font-size: 22px;
      margin-left: 20px;
    }
  }
  .btn {
    width: 512px;
    height: 92px;
    margin: 0 auto;
    border-radius: 46px;
    overflow: hidden;
    background: url("../assets/button.png") no-repeat;
    background-size: 100%;
    font-size: 36px;
    color: #fff;
    line-height: 92px;
    text-align: center;
  }
  .cj {
    width: 400px;
    height: 400px;
  }
}
</style>
